var _rect, _ellipse, _rect2, _ellipse2, _circle, _circle2, _circle3, _circle4, _rect3, _rect4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse3, _ellipse4, _circle10, _circle11, _circle12, _circle13, _path, _path2, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _line, _line2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteampunkAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 700,
    viewBox: "0 0 500 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 700,
    fill: "#2c2c2c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 600,
    rx: 200,
    ry: 40,
    fill: "#7f5a2b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 520,
    width: 300,
    height: 80,
    fill: "#a57238"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 550,
    rx: 150,
    ry: 20,
    fill: "#5d3c1b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 575,
    r: 30,
    fill: "#3c3c3c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 150 575",
    to: "360 150 575",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 575,
    r: 20,
    fill: "#4c4c4c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 150 575",
    to: "0 150 575",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 575,
    r: 30,
    fill: "#3c3c3c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 350 575",
    to: "0 350 575",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 575,
    r: 20,
    fill: "#4c4c4c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 350 575",
    to: "360 350 575",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 250,
    width: 180,
    height: 270,
    fill: "#7f5a2b",
    rx: 15,
    ry: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 255,
    width: 170,
    height: 260,
    fill: "#a57238",
    rx: 15,
    ry: 15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 450,
    r: 12,
    fill: "#4c4c4c"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 425,
    r: 12,
    fill: "#4c4c4c"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 425,
    r: 12,
    fill: "#4c4c4c"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 475,
    r: 12,
    fill: "#4c4c4c"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 475,
    r: 12,
    fill: "#4c4c4c"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 150,
    rx: 140,
    ry: 30,
    fill: "#7f5a2b"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 150,
    rx: 130,
    ry: 20,
    fill: "#a57238"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 20,
    fill: "#3c3c3c"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 150,
    r: 20,
    fill: "#3c3c3c"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 12,
    fill: "#7f5a2b"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 150,
    r: 12,
    fill: "#7f5a2b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 160 190 Q 200 230 180 300",
    stroke: "#7f5a2b",
    strokeWidth: 8,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "8;4;8",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 340 190 Q 300 230 320 300",
    stroke: "#7f5a2b",
    strokeWidth: 8,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "8;4;8",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 320,
    r: 20,
    fill: "#3c3c3c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 140 320",
    to: "360 140 320",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 320,
    r: 10,
    fill: "#a57238"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 320,
    r: 5,
    fill: "#4c4c4c"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 320,
    r: 20,
    fill: "#3c3c3c"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 360 320",
    to: "0 360 320",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 320,
    r: 10,
    fill: "#a57238"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 320,
    r: 5,
    fill: "#4c4c4c"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 300,
    r: 50,
    fill: "#3c3c3c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "50;55;50",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 300,
    r: 40,
    fill: "#a57238"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "40;45;40",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 300,
    r: 10,
    fill: "#3c3c3c"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 300,
    x2: 270,
    y2: 260,
    stroke: "#4c4c4c",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 250 300",
    to: "360 250 300",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 300,
    x2: 230,
    y2: 330,
    stroke: "#4c4c4c",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 250 300",
    to: "0 250 300",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 140,
    rx: 10,
    ry: 5,
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "140;120;140",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.1;0.4",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 140,
    rx: 10,
    ry: 5,
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "140;120;140",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.1;0.4",
    dur: "3s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteampunkAbout);
export default __webpack_public_path__ + "static/media/steampunk-about.967f5c47ec6c939a6d33d6d2f1d14812.svg";
export { ForwardRef as ReactComponent };